function getQueryParams(query: Record<string, string | number>): string {
  return Object.keys(query)
    .map(key => `${key}=${query[key]}`)
    .join('&');
}

export { getQueryParams };
